import Box from 'assets/components/box/Box';
import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageError from 'assets/components/page/themes/Theme.Page.Error';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import { getLocales } from 'assets/locales/Locale';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';
import { ProviderAction, useProviderProvider } from '../Provider.Hooks';

export default function ProviderList() {
  const { lang } = getLocales();
  const { listApi, pageRouter, permissions } = useProviderProvider();

  return !listApi.payload && !listApi.isExecuting && listApi.apiCounter > 0 ? (
    <Page
      class={ThemePageError}
      sidebar={<Icon class="fas-clipboard-list" />}
      header={lang.tiers}
      render={lang.noInfo}
    />
  ) : (
    <table className={ThemeTableSimple}>
      <thead>
        <tr>
          <th>{lang.name}</th>
          <th>{lang.address}</th>
          <th data-actions>{lang.actions}</th>
        </tr>
      </thead>
      <tbody>
        <DataMap
          data={listApi.payload?.data}
          render={({ data: provider }) => (
            <tr key={provider.id}>
              <td>{provider.name}</td>
              <td>{provider.fullAddress}</td>
              <td>
                <Box class={ThemeWrapperStack}>
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: provider.id.toString(),
                      action: ProviderAction.EDIT,
                    }}
                    disabled={!permissions.EDIT_PROVIDER}
                    class={ThemeButtonCircle}
                    media={<Icon class="fas-edit" />}
                    htmlElementProps={{ title: lang.edit }}
                    active
                  />
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: provider.id.toString(),
                      action: ProviderAction.DELETE,
                    }}
                    disabled={!permissions.DELETE_PROVIDER}
                    class={ThemeButtonCircle}
                    media={<Icon class="fas-trash" />}
                    htmlElementProps={{ title: lang.delete }}
                    active
                  />
                </Box>
              </td>
            </tr>
          )}
        />
      </tbody>
    </table>
  );
}
